/* ========================================================================
   Navigation
 ========================================================================== */

app.navigation = (function () {
  'use strict';

  function init() {
    initMenu();
    initSubmenu();
    initFloatingButton();
  }

  const KEY_ENTER = 'Enter';
  const KEY_SPACE = 'Space';
  const KEY_ESCAPE = 'Escape';

  let _isKeyboardEvent = false;
  const _mediaQueryIsMobile = window.matchMedia('(max-width: 767.98px)');
  // const _mainNav = document.querySelector('[data-main-nav]');
  const _trigger = document.querySelector('[data-main-nav-trigger]');
  const _container = document.querySelector('[data-main-nav-container]');
  const _close = document.querySelector('[data-main-nav-close]');
  const _body = document.querySelector('body');
  // const _scrollWatcher = document.querySelector('[data-scroll-watcher]');
  const _floatingNavButton = document.querySelector('[data-floating-nav-button]');

  //
  // Menu
  //

  function initMenu() {
    if (!_trigger || !_container) return;

    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('pageWrapper')) {
        _isKeyboardEvent = util.isKeyboardEvent(event);
        closeMenu();
      }
    });

    _trigger.addEventListener('click', (event) => {
      _isKeyboardEvent = util.isKeyboardEvent(event);
      toggleMenu();
    });

    _close.addEventListener('click', (event) => {
      _isKeyboardEvent = util.isKeyboardEvent(event);
      closeMenu();
    });

    _container.addEventListener('keydown', (event) => {
      if (event.code === KEY_ESCAPE) {
        _isKeyboardEvent = true;
        closeMenu();
      }
    });

    // _floatingNavButton.addEventListener('click', (event) => {
    //   toggleMenu(false);
    // });

    // // navigation observer
    // if (_scrollWatcher) {
    //   const navObserver = new IntersectionObserver(toggleFloatingNavButton);
    //   navObserver.observe(_scrollWatcher);
    // }
  }

  // function toggleFloatingNavButton() {
  //   if (_scrollWatcher.getBoundingClientRect().top <= -1) {
  //     _floatingNavButton.classList.add('is-visible');
  //   } else {
  //     _floatingNavButton.classList.remove('is-visible');
  //   }
  // }

  function toggleMenu() {
    if (_trigger.getAttribute('aria-expanded') === 'false') {
      openMenu();
    } else {
      closeMenu();
    }
  }

  function openMenu() {
    _container.classList.add('is-open');
    _container.style.visibility = 'visible';
    _body.dataset.menu = 'open';

    // a11y: switch focus to first link
    const firstMenuItem = _container.querySelector('.navExt__sub__link');
    if (_isKeyboardEvent && firstMenuItem) firstMenuItem.focus();

    // a11y: update aria attributes
    _trigger.setAttribute('aria-label', _trigger.dataset.closeText);
    _trigger.setAttribute('aria-expanded', true);
  }

  function closeMenu() {
    resetSubmenu();

    _container.style.transform = 'translateY(-100%)';
    _body.dataset.menu = 'closing';

    window.setTimeout(() => {
      _container.classList.remove('is-open');
      _body.classList.remove('has-open-menu');

      // a11y: switch focus back to trigger
      if (_isKeyboardEvent) _trigger.focus();

      // a11y: update aria attributes
      _trigger.setAttribute('aria-label', _trigger.dataset.openText);
      _trigger.setAttribute('aria-expanded', false);

      _container.style.visibility = null;
      _container.style.transform = null;
      _body.dataset.menu = '';
    }, 500);
  }

  //
  // Submenus
  //

  function initSubmenu() {
    const toggles = document.querySelectorAll('[data-menu-item-toggle]');

    if (!toggles) return;

    toggles.forEach((toggle) => {
      const parent = toggle.parentNode.parentNode;
      const subnav = parent.querySelector('[data-menu-item-sub]');

      if (!parent || !subnav) return;

      toggle.addEventListener('click', (event) => {
        event.preventDefault();

        // Don't do anything if not mobile
        if (_mediaQueryIsMobile.matches === false) return;

        if (parent.classList.contains('is-open') === false) {
          // close all open submenus
          resetSubmenu();

          parent.classList.add('is-open');
          util.slideDown(subnav, 250);

          // a11y: update aria attributes
          toggle.setAttribute('aria-label', toggle.dataset.closeText);
          toggle.setAttribute('aria-expanded', true);
        } else {
          util.slideUp(subnav, 250);
          parent.classList.remove('is-open');

          // a11y: update aria attributes
          toggle.setAttribute('aria-label', toggle.dataset.openText);
          toggle.setAttribute('aria-expanded', false);
        }
      });
    });
  }

  function resetSubmenu() {
    // Don't reset if not mobile
    if (_mediaQueryIsMobile.matches === false) return;

    const toggles = document.querySelectorAll('[data-menu-item-toggle]');
    const activeToggles = document.querySelectorAll('[data-menu-item-toggle][aria-expanded="true"]');

    toggles.forEach((toggle) => {
      toggle.tabIndex = 0;
    });

    if (activeToggles.length === 0) return;

    activeToggles.forEach((toggle) => {
      const parent = toggle.parentNode.parentNode;
      const subnav = parent.querySelector('[data-menu-item-sub]');

      if (!parent || !subnav) return;

      util.slideUp(subnav, 250);
      parent.classList.remove('is-open');

      // a11y: update aria attributes
      toggle.setAttribute('aria-label', toggle.dataset.openText);
      toggle.setAttribute('aria-expanded', false);
    });
  }

  function openAllSubmenus() {
    const toggles = document.querySelectorAll('[data-menu-item-toggle]');

    if (!toggles) return;

    toggles.forEach((toggle) => {
      const parent = toggle.parentNode.parentNode;
      const subnav = parent.querySelector('[data-menu-item-sub]');

      if (!parent || !subnav) return;

      util.slideDown(subnav, 250);
      parent.classList.add('is-open');

      // a11y: update aria attributes
      toggle.setAttribute('aria-label', toggle.dataset.closeText);
      toggle.setAttribute('aria-expanded', true);
      toggle.tabIndex = -1;
    });
  }

  //
  // Handle submenus on window resize
  // Close all submenus on mobile, open all on desktop
  //

  function onWindowResize() {
    if (_mediaQueryIsMobile.matches) {
      resetSubmenu();
    } else {
      openAllSubmenus();
    }
  }

  _mediaQueryIsMobile.addEventListener('change', onWindowResize);
  onWindowResize();

  function initFloatingButton() {
    if (!_floatingNavButton) return;

    let scrolling = false;

    _floatingNavButton.addEventListener('click', (event) => {
      event.preventDefault();
      openMenu();
    });

    window.addEventListener(
      'scroll',
      () => {
        scrolling = true;
      },
      { passive: true }
    );

    setInterval(() => {
      if (scrolling === false) return;
      scrolling = false;

      if (window.scrollY > 500) {
        if (_floatingNavButton.classList.contains('is-in-view')) return;
        _floatingNavButton.classList.add('is-in-view');
      } else {
        if (_floatingNavButton.classList.contains('is-in-view') === false) return;
        _floatingNavButton.classList.remove('is-in-view');
      }
    }, 100);
  }

  // Expose public functions and variables
  return {
    initMenu: initMenu,
    init: init,
  };
})();
